import React from 'react';
import { compose } from 'ramda';
import { connect } from 'react-redux';

import styleFile from './AvailBoardDetail.js';
import RichText from '@synergycms_core/components/generic/RichText';
import Image from '@synergycms_core/components/generic/Image';
import { AvailRateDetail } from '../AvailRateDetail';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import TooltipWrapper from '@synergycms_core/components/generic/TooltipWrapper';
import { Map } from 'immutable';

const AvailBoardDetail = class AvailBoardDetail extends React.Component {
  static displayName = 'AvailBoardDetail';

  render() {
    const { config, theme } = this.props;
    const { classes } = theme.styles;
    const {
      boardAvail,
      selectRoomRate,
      boardId,
      roomId,
      serviceId,
      segment,
      occupGroupId,
      adults,
      childs,
      babies,
      childsInfo,
      isLoyaltyAvail,
      enableLoyaltyTab,
      showTabs,
    } = config;

    const firstBoard = boardAvail.first() || Map();
    const boardName = firstBoard.get('board_name');
    const boardDesc = firstBoard.get('board_description', false);
    const ToolTipBoard = () =>
      boardDesc ? (
        <div className={[classes.boardInfo]}>
          <TooltipWrapper
            popover={<span>{boardDesc}</span>}
            bottomLimit={100}
            popoverStyle={classes.boardTooltip}
            typeTooltip={'boardTooltip-' + boardId + '-' + roomId}
            pointerStyle={classes.tooltipPointerStyle}
            posX={'middle'}
            posY={'bottom'}>
            <Image unicodeContent="e143" innerStyle={['gold']}/>
          </TooltipWrapper>
        </div>
      ) : (
        ''
      );
    return (
      <div className={[boardAvail.size > 1 ? classes.doubleRate : classes.singleRate]}>
        <div className={[classes.boardTitle]}>
          <RichText innerStyle={['roboto16Black']} text={boardName} tabIndex={0}/>
          <ToolTipBoard/>
        </div>
        <ul className={classes.hotelSelection}>
          {boardAvail.keySeq().map(refType => {
            const rateAvail = boardAvail.get(refType);

            return (
              <li key={refType}>
                <AvailRateDetail
                  rateAvail={rateAvail}
                  selectRoomRate={selectRoomRate}
                  innerStyle={refType === 'any' && boardAvail.size > 1 ? ['defaultStyle'] : ['defaultStyle']}
                  boardId={boardId}
                  roomId={roomId}
                  serviceId={serviceId}
                  segment={segment}
                  refType={refType}
                  occupGroupId={occupGroupId}
                  adults={adults}
                  childs={childs}
                  babies={babies}
                  childsInfo={childsInfo}
                  isLoyaltyAvail={isLoyaltyAvail}
                  enableLoyaltyTab={enableLoyaltyTab}
                  showTabs={showTabs}
                />
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
};

const mapDispatchToProps = dispatch => {
  return {};
};

const mapStateToProps = (store, ownProps) => {
  return {};
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  PropertyManager([
    'boardAvail',
    'boardId',
    'selectRoomRate',
    'roomId',
    'segment',
    'serviceId',
    'occupGroupId',
    'adults',
    'childs',
    'babies',
    'childsInfo',
    'isLoyaltyAvail',
    'enableLoyaltyTab',
    'showTabs',
  ]),
  withThemeJSS({ styleFile, index: 300 })
)(AvailBoardDetail);
